import { useState } from "react";
import { confirmPasswordReset } from "firebase/auth";
// import { auth } from "../firebase";
import { useSearchParams, useNavigate } from "react-router-dom";
import { auth } from "../firebaseconfig/firebase";


const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const oobCode = params.get("oobCode");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleReset = async () => {
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await confirmPasswordReset(auth, oobCode, password);
      navigate("/");
    } catch (err) {
      setError("Invalid or expired reset link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-blue-950 min-h-screen flex items-center justify-center">
      <div className="bg-[#0f172a] p-6 rounded text-white w-[90%] max-w-md">
        <h2 className="text-2xl font-bold mb-4">Reset Password</h2>

        <input
          type="password"
          placeholder="New password"
          className="w-full p-2 rounded bg-transparent border mb-3"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p className="text-red-400 text-sm">{error}</p>}

        <button
          onClick={handleReset}
          disabled={loading}
          className="bg-blue-700 w-full py-2 rounded mt-4"
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
